import { Pipe, PipeTransform } from '@angular/core';
import { Field, FieldType } from '@shared/models/field.model';

@Pipe({
  name: 'showField'
})
export class ShowFieldPipe implements PipeTransform {

  transform(field: Field, type?: FieldType['type']): any {
    return field.type === type;
  }

}
